import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

/**
 * The expanded view of one slide image or clip (RA-2695), rendered inside the release card so it stacks
 * above the modal. Stills are `contain`; clips get controls and start from the beginning.
 *
 * 🔴 Esc closes the lightbox only. NgbModal listens for Escape on its window element and dismisses unless
 * the event was handled, so focus moves in here on open and Escape is caught on this element itself with
 * `preventDefault` + `stopPropagation` — a `document` listener would fire too late to stop the modal.
 */
@Component({
  selector: 'rms-release-media-lightbox',
  templateUrl: './release-media-lightbox.component.html',
  styleUrls: ['./release-media-lightbox.component.scss'],
  standalone: false
})
export class ReleaseMediaLightboxComponent implements AfterViewInit {

  @Input() public url: string | null = null;
  @Input() public isVideo = false;
  @Input() public alt = '';

  @Output() public closed = new EventEmitter<void>();

  @ViewChild('closeButton') private readonly closeButton: ElementRef<HTMLButtonElement>;

  public ngAfterViewInit(): void {
    this.closeButton?.nativeElement.focus();
  }

  public onEscape(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.closed.emit();
  }

  /** Closes only on a click on the scrim itself, never on the media. */
  public onBackdrop(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.closed.emit();
    }
  }
}
